import { Injectable } from '@angular/core';
import { Colores} from '@core/interfaces/catalogos.intefaces';
import { Request } from '@core/models/requests.model';

@Injectable({
  providedIn: 'root',
})
export class ColoresSeminuevosService {

  private url = `ventas/catalogos/seminuevos/color/search`;

  constructor(
    private request:Request
  ) { }

  getColores(body:any) {
    const options = { headers: this.request.headers };
    return this.request.Post<Colores>( this.url,body,options);
  }

  formatValues(data: any[], keyProp: string, valueProp: string, colorProp: string): { key: any; value: any; color?:any }[] {
    return data.map(item => ({ key: item[keyProp], value: item[valueProp], color: item[colorProp] }));
  }

}

